// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: what the page under the Konvo panel has open that the routes alone do not say.
// The mail reader registers the email it shows with its starting points and the local
// flows behind them (the drafted-task form, the reply composer), so the panel's quick
// tasks can offer the same ones. Chats and ClickUp tasks are read from their own stores.

import type {StarterContext} from '@app/features/konvo_panel/state/starters';
import type {Starter} from '@konvo/schema/src/domains/konvo/AssistantEngagement';
import {makeAutoObservable} from 'mobx';

export interface MailPanelFocus {
	messageId: string;
	context: StarterContext;
	starters: ReadonlyArray<Starter>;
	perform: Partial<Record<Starter, () => void>>;
}

class PanelFocusStore {
	mail: MailPanelFocus | null = null;

	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
	}

	setMail(focus: MailPanelFocus): void {
		this.mail = focus;
	}

	/** Only the reader that registered it clears it (a newer email may have replaced it). */
	clearMail(messageId: string): void {
		if (this.mail?.messageId === messageId) this.mail = null;
	}
}

export default new PanelFocusStore();
